// DBASE >> @/users/:uId/mindmovie/
//    - dateoflastupdate (like self-check-in)
//        - categories: ''
//        - posts: ''
//    - categories (like a program)
//        - id: {categoryName}
//    - posts (like a program)
//        - id: {
//            type: 'youtube' || 'imgur',
//            src: '',
//            startTime: '',
//            categories: [ '', ... ],
//        }
//

/* ***** DOLU date of last update *****/
// Date Of Last Update
function generateNewDolu() {
  const now = new Date();

  const pad = (num) => String(num).padStart(2, '0');

  const formatted =
    now.getFullYear().toString() +
    pad(now.getMonth() + 1) +
    pad(now.getDate()) +
    '@' +
    pad(now.getHours()) +
    pad(now.getMinutes()) +
    pad(now.getSeconds());

  console.log('*** MindMovieServices >> new dateOfLastUpdate ***', formatted);
  return formatted;
}
async function getDoluFromDbase(uId, token) {
  // returns a dolu object, or false
  // console.log('*** MindMovieServices >> getDoluFromDbase(uId, token) ***', uId, token);

  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/users/${uId}/mindmovie/dateoflastupdate.json?auth=${token}`);
  const dbDolu = await response.json();

  // error handling
  if (!response.ok) {
    throw new Error(response.message || `MindMovieService >> Failed to get user's MindMovie dateOfLastUpdate`);
  }
  if (dbDolu) {
    return dbDolu;
  } else {
    return false;
  }
}
async function updateDoluCategories(uId, token, doluString) {

  // API call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/users/${uId}/mindmovie/dateoflastupdate.json?auth=${token}`, {
    method: 'PATCH',
    body: JSON.stringify({categories: doluString}),
  });
  const responseData = await response.json();

  // error handling
  if(!response.ok) {
    throw new Error(response.message || 'MindMovieServices >> Failed to update dolu.categories');
  }

  // return data
  // console.log('*** MindMovieServices >> finished updating dolu.categories in dbase ***',  doluString, responseData);
  return responseData;
}
async function updateDoluPosts(uId, token, doluString) {
  // API call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/users/${uId}/mindmovie/dateoflastupdate.json?auth=${token}`, {
    method: 'PATCH',
    body: JSON.stringify({posts: doluString}),
  });
  const responseData = await response.json();

  // error handling
  if(!response.ok) {
    throw new Error(response.message || 'MindMovieServices >> Failed to update dolu.categories');
  }

  // return data
  return responseData;
}



/* ***** CATEGORIES *****/
// Categories - Create One
async function createOneCategory(uId, token, categoryName) {
  // RETURNS new thing, or false
  // console.log('*** MindMovieServices >> createOneCategory(categoryName) ***', categoryName);

  // API call
  const newCategory = {
    name: categoryName,
  };
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/users/${uId}/mindmovie/categories.json?auth=${token}`, {
    method: 'POST',
    body: JSON.stringify(newCategory),
  });
  const responseData = await response.json();

  // error handling
  if(!response.ok) {
    throw new Error(response.message || 'Failed to add a new MindMovie Category');
  }

  // return data
  return responseData;
}
// Categories - Read All
async function readAllCategories(uId, token) {
  // console.log('*** MindMovieServices >> readAllCategories() ***');

  // API Call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/users/${uId}/mindmovie/categories.json?auth=${token}`);
  const responseData = await response.json();

  // error handling
  if (!response.ok) {
    throw new Error(response.message || 'MindMovieServices >> Failed to get MindMovie Categories');
  }
  return responseData;

}
// Categories - Read One
// async function readOneCategory(uId, token, categoryId) { console.log('*** readOneCategory(categoryId) ***', categoryId); }
// Categories - Update One
async function updateOneCategory(uId, token, categoryId, updatedCategory) {
  // console.log('*** updateOneCategory(categoryId, updatedCategory) ***', categoryId, updatedCategory);

  // API call to dbase
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/users/${uId}/mindmovie/categories/${categoryId}.json?auth=${token}`, {
    method: 'PATCH',
    body: JSON.stringify(updatedCategory)
  });
  const responseData = await response.json();

  // error handling
  if (!response.ok) {
    throw new Error(response.message || 'MindMovieServices >> Failed to update a MindMovie Category');
  }

  // return data
  return responseData;

}
// Categories - Delete One
async function deleteOneCategory(uId, token, categoryId) {
  console.log('*** MindMovieServices >> deleteOneCategory(categoryId) ***', categoryId);

  // API call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/users/${uId}/mindmovie/categories/${categoryId}.json?auth=${token}`, {
    method: 'DELETE',
  });
  const responseData = await response.json();

  // error handling
  if (!response.ok) {
    throw new Error(response.message || 'Failed to delete a MindMovie Category');
  }

  return responseData;
}



/* ***** POSTS *****/
// Posts - Create One
async function createOnePost(uId, token, post) {
  // RETURNS newly created Post's id, or error
  console.log('*** MindMovieServices >> createOnePost(categoryName) ***', post);

  // API call to dbase
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/users/${uId}/mindmovie/posts.json?auth=${token}`, {
    method: 'POST',
    body: JSON.stringify(post)
  });
  const responseData = await response.json();
  console.log('*** MindMovieServices >> responseData ***', responseData);

  // error handling
  if (!response.ok) {
    throw new Error(response.message || 'MindMovieServices >> Failed to create new Post');
  }

  return responseData;
}
// Posts - Read All
async function readAllPosts(uId, token) {
  // console.log('*** readAllPosts() ***', uId, token);

  // API Call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/users/${uId}/mindmovie/posts.json?auth=${token}`);
  const responseData = await response.json();

  // error handling
  if (!response.ok) {
    throw new Error(response.message || 'MindMovieServices >> Failed to get MindMovie Posts');
  }
  return responseData;

}
// Posts - Read One
// async function readOnePost(uId, token, postId) { console.log('*** readOnePost(categoryId) ***', postId); }
// Posts - Update One
async function updateOnePost(uId, token, postId, updatedPost) {
  // console.log('*** MindMovieServices >> updateOnePost(postId, updatedPost) ***', postId, updatedPost);
  // API call to dbase
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/users/${uId}/mindmovie/posts/${postId}.json?auth=${token}`, {
    method: 'PATCH',
    body: JSON.stringify(updatedPost)
  });
  const responseData = await response.json();

  // error handling
  if (!response.ok) {
    throw new Error(response.message || 'MindMovieServices >> Failed to update a MindMovie Category');
  }

  // return data
  return responseData;
}
// Posts - Delete One
async function deleteOnePost(uId, token, postId) {
  console.log('*** MindMovieServices >> deleteOnePost(categoryId) ***', postId);

  // API call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/users/${uId}/mindmovie/posts/${postId}.json?auth=${token}`, {
    method: 'DELETE',
  });
  const responseData = await response.json();

  // error handling
  if (!response.ok) {
    throw new Error(response.message || 'MindMovieServices >> Failed to delete a MindMovie Post');
  }

  return responseData;
}
// Posts - Like One Post
async function likeOnePost(uId, token, postId, likes) {
  // API call to dbase
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/users/${uId}/mindmovie/posts/${postId}.json?auth=${token}`, {
    method: 'PATCH',
    body: JSON.stringify({ likes: likes }),
  });
  const responseData = await response.json();

  // error handling
  if (!response.ok) {
    throw new Error(response.message || `MindMovieServices >> Failed to update a MindMovie Post's Likes`);
  }

  // return data
  return responseData;
}
// Posts >> Comments - Create One
async function createOnePostComment(uId, token, postId, comment) {
  // RETURNS newly created Post > Comment's id, or error
  // comment = { comment: '', dateCreated: todayActual };
  console.log('*** MindMovieServices >> createOnePostComment) ***', postId, comment);
  // API call to dbase
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/users/${uId}/mindmovie/posts/${postId}/comments.json?auth=${token}`, {
    method: 'POST',
    body: JSON.stringify(comment),
  });
  const responseData = await response.json();

  // error handling
  if (!response.ok) {
    throw new Error(response.message || 'MindMovieServices >> Failed to create new Post >> Comment');
  }

  return responseData;
}
// Posts >> Comments - Delete One
async function deleteOnePostComment(uId, token, postId, commentId){
  console.log('*** MindMovieServices >> deleteOnePost(categoryId) ***', postId, commentId);

  // API call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/users/${uId}/mindmovie/posts/${postId}/comments/${commentId}.json?auth=${token}`, {
    method: 'DELETE',
  });
  const responseData = await response.json();

  // error handling
  if (!response.ok) {
    throw new Error(response.message || `MindMovieServices >> Failed to delete a MindMovie Post's Comment`);
  }

  return responseData;
}



export {
  generateNewDolu, getDoluFromDbase, updateDoluCategories, updateDoluPosts,
  createOneCategory, readAllCategories, updateOneCategory, deleteOneCategory,
  createOnePost, readAllPosts, updateOnePost, deleteOnePost,
  likeOnePost,
  createOnePostComment, deleteOnePostComment,
};
